<lib-filter-header
  #ixFilterItemHeader
  [customTitle]="this.filterItemHeaderTitle"
  [label]="this.label"
  [icon]="this.filterItemHeaderIcon"
  [valueAll]="this.valueAll"
  [value]="this.value"
  [divFocusClass]="this.filterItemHeaderDivFocusClass"
  [disabledElement]="this.disabledElement"
  [isFocusOn]="this.focusFilterItemHeader"
  (ixClick)="this.toggleOverlayPanel($event)"
  (click)="this.focusFilterInput()"
/>

<p-popover
  #op1
  ixOverlay
  class="CssFilterOverlayPanel"
  [styleClass]="this.overlayPanelStyleClass"
  [appendTo]="this.appendTo"
  [isOverlayInFixedContainer]="this.isLookupInFixedContainer"
  [autoZIndex]="this.autoZIndex"
  [baseZIndex]="this.baseZIndex"
  (confirm)="onConfirm($event)"
  (onShow)="onShow()"
  (onHide)="onHide()"
>
  <ng-template #content>
    <div
      #focusDivElement
      style="border: none"
      tabindex="0"
      [ngClass]="this.pStyleClass ? 'p-listbox ' + this.pStyleClass : 'p-listbox'"
      [ngStyle]="this.stylePanel"
      [formGroup]="this.ixFormGroupUtil.formGroup"
      (keydown)="onKeydown($event)"
      (click)="focusDataDiv()"
    >
      <ng-content select=".aboveSearchMode" />

      <!--Search mode-->
      <p-tabs
        class="CssIxTabView"
        [value]="this.searchMode"
        (valueChange)="this.onSearchMode($event)"
      >
        <p-tablist
          [ngStyle]="{
            display: !(
              this.advancedFieldVsebuje !== undefined ||
              (this.advancedFieldOd !== undefined && this.advancedFieldDo !== undefined) ||
              this.advancedFieldMnozicaElem !== undefined ||
              this.advancedFieldObstaja !== undefined
            )
              ? 'none'
              : 'flex',
          }"
        >
          <p-tab [value]="'field'">Izbira</p-tab>
          @if (this.advancedFieldVsebuje !== undefined) {
            <p-tab [value]="'advancedFieldVsebuje'">Vsebuje</p-tab>
          }
          @if (this.advancedFieldVsebuje !== undefined) {
            <p-tab [value]="'advancedFieldSeZacne'">Se začne</p-tab>
          }
          @if (this.advancedFieldOd !== undefined && this.advancedFieldDo !== undefined) {
            <p-tab [value]="'advancedFieldOdDo'">Od-Do</p-tab>
          }
          @if (this.advancedFieldMnozicaElem !== undefined) {
            <p-tab [value]="'advancedFieldMnozicaElem'">Seznam</p-tab>
          }
          @if (this.advancedFieldObstaja !== undefined) {
            <p-tab [value]="'advancedFieldObstaja'">Obstaja</p-tab>
          }
          @if (this.advancedFieldNapredno !== undefined) {
            <p-tab [value]="'advancedFieldNapredno'">Napredno</p-tab>
          }
          <div class="p-tab" style="display: flex; width: 15px; justify-content: center">
            @if (this.showHelpIcon) {
              <a
                class="CssTopBar"
                href="#"
                style="margin: auto"
                (click)="this.showHelpIzbiraIzSeznama($event)"
              >
                <i class="topbar-icon pi pi-fw pi-question-circle"></i>
                <span class="topbar-item-name">Help</span>
              </a>
            }
          </div>
          @if (this.showCloseIcon) {
            <div
              class="p-tab"
              style="display: flex; width: 15px; justify-content: center"
              tabindex="0"
              (click)="this.op1?.hide()"
              (keyup)="this.op1?.hide()"
            >
              <i pButtonIcon class="pi pi-times"></i>
            </div>
          }
        </p-tablist>
        <p-tabpanels style="padding: 5px">
          <p-tabpanel id="field" [value]="'field'">
            <ng-content select=".belowSearchMode" />

            <!-- Groups list -->
            @if (!!groupsList && groupsList.length > 0) {
              <div>
                @for (group of groupsList; track group; let i = $index) {
                  <li style="display: inline-block; margin-top: 2px; margin-right: 2px">
                    @if (!!group && group.getGroupSize() > 0) {
                      <a
                        class="p-lookup-group-item"
                        id="{{ group.groupId }}"
                        [ngClass]="{
                          'p-group-selected-color colorPrimary': group.isGroupSelected(),
                          'p-group-unselected-color': true,
                        }"
                        tabindex="0"
                        (keyup.enter)="this.onGroupClick(group, i, $event)"
                        (click)="this.onGroupClick(group, i, $event)"
                        >{{ group.groupName }}</a
                      >
                    }
                    <!-- ({{group.groupTag}}) S:{{group.getGroupSize()}} I:{{group.numSelected}} -->
                  </li>
                }
              </div>
            }

            @if (!!groupsList && groupsList.length > 0) {
              <div
                class=""
                [style.padding-top]="'0px'"
                [style.padding-left]="'0px'"
                [style.border-bottom]="'1px solid'"
                [style.border-bottom-color]="'#bdc3c9'"
                [style.margin-bottom]="'10px'"
                [style.padding-bottom]="'10px'"
              ></div>
            }

            <!-- Selected items-->
            @if (this.showSelectedItems) {
              <div
                class="grow1 flex-wrapper"
                [ngClass]="{
                  selectedItemsDiv: !!this.selectedValues && this.selectedValues.length > 0,
                }"
              >
                <ul class="selectedItemsUl flex-wrap">
                  @if (!!this.selectedValues && this.selectedValues.length > 0) {
                    <li
                      style="
                        list-style-type: none;
                        align-self: center;
                        overflow: visible;
                        padding: 0;
                      "
                      class="p-autocomplete-chip-icon"
                    >
                      <span
                        class="pi pi-fw pi-times pi-lg"
                        tabindex="0"
                        (click)="removeAllItems($event)"
                        (keyup)="removeAllItems($event)"
                      ></span>
                    </li>
                  }
                  @for (item of this.selectedValues; track item; let i = $index) {
                    <li class="p-autocomplete-chip p-highlight">
                      <span
                        tabindex="0"
                        class="p-autocomplete-chip-icon pi pi-fw pi-times"
                        (click)="removeItem(i, $event, true)"
                        (keyup)="removeItem(i, $event, true)"
                      ></span>
                      <span class="p-autocomplete-chip-label">{{
                        this.itemDisplayField(item)
                      }}</span>
                    </li>
                  }
                </ul>
              </div>
            }
            <!-- Filter input -->
            <div class="p-listbox-header" style="display: flex">
              <!-- Checkboxs -->

              @if (!single) {
                <div
                  tabindex="0"
                  class="p-checkbox p-component"
                  style="margin: auto; cursor: pointer; left: -6.5px"
                  [ngClass]="{ 'p-highlight p-checkbox-checked': isSelectedAll() }"
                  (click)="this.onClickSelectedAll($event)"
                  (keyup)="this.onClickSelectedAll($event)"
                >
                  <div class="p-checkbox-box p-component">
                    <span
                      class="p-checkbox-icon p-clickable"
                      [ngClass]="{ 'pi pi-check': isSelectedAll() }"
                    ></span>
                  </div>
                </div>
              }
              <div
                class="p-listbox-filter-container"
                style="width: calc(100% - 20px); position: relative"
              >
                <input
                  #inputEl
                  ixInput
                  type="text"
                  role="textbox"
                  class="p-inputtext"
                  style="padding-right: 25px; width: 100%"
                  placeholder="{{ this.placeholder }}"
                  [tabindex]="1"
                  [ngModelOptions]="{ standalone: true }"
                  [(ngModel)]="this.tempSearchValue"
                  (escape)="this.focusDataDiv()"
                  (keyup)="onFilter($event)"
                  (focus)="onInputFocus()"
                />
                <!--(focus)="onInputFocus($event)" -->
                <span class="pi pi-search"></span>
                @if (this.loading) {
                  <span class="loadingIconClass">
                    <i class="pi pi-spinner pi-spin pi-fw"></i>
                  </span>
                }
              </div>
              <!--          If tabs are not displayed, show the icons in the same row as the search bar.-->
              @if (
                (this.showCloseIcon || this.showHelpIcon) &&
                !(
                  this.advancedFieldVsebuje !== undefined ||
                  (this.advancedFieldOd !== undefined && this.advancedFieldDo !== undefined) ||
                  this.advancedFieldMnozicaElem !== undefined ||
                  this.advancedFieldObstaja !== undefined
                )
              ) {
                <div class="closeButton" style="padding-left: 0.5rem">
                  @if (this.showHelpIcon) {
                    <a
                      class="CssTopBar"
                      style="margin: auto"
                      href="#"
                      (click)="this.showHelpIzbiraIzSeznama($event)"
                    >
                      <i class="topbar-icon pi pi-fw pi-question-circle"></i>
                      <span class="topbar-item-name">Help</span>
                    </a>
                  }
                  @if (this.showCloseIcon) {
                    <button
                      pButton
                      type="button"
                      style="border: 0; float: right; border-radius: 50%"
                      class="p-button-rounded p-button-secondary"
                      title="Zapri"
                      (click)="this.closeOverlay()"
                    >
                      <i pButtonIcon class="pi pi-times"></i>
                    </button>
                  }
                </div>
              }
            </div>

            <div>
              @if (!single && this.hasHeaderElement) {
                <div
                  class="p-checkbox p-component"
                  style="float: left; width: 30px; margin: 0"
                ></div>
              }
              <div
                #headerDivElement
                class="p-listbox-header-w-checkbox header-labels"
                style="border-top: 0; border-left: 0; border-right: 0"
              >
                <ng-content />
              </div>

              <!-- Lookup content -->
              <div
                #dataDivElement
                ixSelectable
                class="p-listbox-list-wrapper divOverflow"
                style="outline: none"
                [tabindex]="2"
                [style.max-height]="scrollHeight"
                [items]="this.options"
                [scrollableParent]="dataDivElement"
              >
                <!-- #dataDivElement -->
                <ul class="p-listbox-list">
                  @for (option of options; track option; let i = $index) {
                    <li
                      tabindex="0"
                      style="padding-left: 0.5em"
                      [ngClass]="{
                        'p-lookup-item CssNoselect': true,
                        selected: isSelected(option),
                        'p-lookup-item-focus': isSingleSelected(option),
                      }"
                      (click)="onOptionClick($event, option)"
                      (keyup)="onOptionClick($event, option)"
                    >
                      <!-- Checkboxs -->
                      @if (!single) {
                        <div
                          class="p-checkbox p-component"
                          style="float: left; margin-top: 0.5em; margin-right: 0; width: 30px"
                          [ngClass]="{ 'p-highlight p-checkbox-checked': isSelected(option) }"
                        >
                          <div class="p-checkbox-box p-component">
                            <span
                              class="p-checkbox-icon p-clickable"
                              [ngClass]="{ 'pi pi-check': isSelected(option) }"
                            ></span>
                          </div>
                        </div>
                      }
                      <!-- Data template -->
                      <ng-container
                        *ngTemplateOutlet="
                          this.itemTemplate;
                          context: { $implicit: option.data, index: i }
                        "
                      />
                    </li>
                  }
                </ul>
              </div>
            </div>
            @if (steviloZapisov !== null && steviloZapisov === 0 && emptyMessage && displayFooter) {
              <div class="footerStyle sticky bottom" [style.padding-top]="'5px'">
                <div>{{ emptyMessage }}</div>
              </div>
            }
            @if (
              steviloZapisov &&
              ((steviloZapisov >= numRows && readMode === 0) ||
                (overLimitRead && readMode === 2)) &&
              displayFooter
            ) {
              <div class="footerStyle">
                <div>
                  {{
                    this.footerMessage
                      ? this.footerMessage
                      : 'Prikazanih je prvih ' + numRows + ' zapisov'
                  }}
                </div>
              </div>
            }
          </p-tabpanel>
          @if (this.advancedFieldVsebuje !== undefined) {
            <p-tabpanel id="advancedFieldVsebuje" [value]="'advancedFieldVsebuje'">
              <ix-input
                #advancedFieldVsebujeComponent
                label=""
                field="advancedFieldVsebuje"
                style="width: 100%; display: block"
                [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
                [placeholder]="this.advancedFieldVsebujePlaceholder"
                [readOnlyForce]="false"
                (ixChange)="this.onLookupChange($event, true)"
              />
            </p-tabpanel>
          }
          @if (this.advancedFieldSeZacne !== undefined) {
            <p-tabpanel id="advancedFieldSeZacne" [value]="'advancedFieldSeZacne'">
              <ix-input
                #advancedFieldSeZacneComponent
                label=""
                field="advancedFieldSeZacne"
                style="width: 100%; display: block"
                [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
                [placeholder]="this.advancedFieldSeZacnePlaceholder"
                [readOnlyForce]="false"
                (ixChange)="this.onLookupChange($event, true)"
              />
            </p-tabpanel>
          }
          @if (this.advancedFieldOd !== undefined && this.advancedFieldDo !== undefined) {
            <p-tabpanel id="advancedFieldOdDo" [value]="'advancedFieldOdDo'">
              @if (!mask || mask === '') {
                <ix-input
                  #advancedFieldOdComponent
                  label="Od"
                  field="advancedFieldOd"
                  style="width: 100%; display: block"
                  [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
                  [placeholder]="this.advancedFieldOdDoPlaceholder"
                  [readOnlyForce]="false"
                  (ixChange)="this.onLookupChange($event, true)"
                />
                <ix-input
                  #advancedFieldDoComponent
                  label="Do"
                  field="advancedFieldDo"
                  style="width: 100%; display: block"
                  [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
                  [placeholder]="this.advancedFieldOdDoPlaceholder"
                  [readOnlyForce]="false"
                  (ixChange)="this.onLookupChange($event, true)"
                />
              }
              @if (mask && mask !== '') {
                <ix-input-mask
                  #advancedFieldOdComponent
                  label="Od"
                  field="advancedFieldOd"
                  style="width: 100%; display: block"
                  [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
                  [readOnlyForce]="false"
                  [mask]="this.mask"
                  (ixChange)="this.onLookupChange($event, true)"
                  (escape)="this.onLookupChange($event, true)"
                />
                <ix-input-mask
                  #advancedFieldDoComponent
                  label="Do"
                  field="advancedFieldDo"
                  style="width: 100%; display: block"
                  [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
                  [readOnlyForce]="false"
                  [mask]="this.mask"
                  (ixChange)="this.onLookupChange($event, true)"
                  (escape)="this.onLookupChange($event, true)"
                />
              }
            </p-tabpanel>
          }
          @if (this.advancedFieldMnozicaElem !== undefined) {
            <p-tabpanel id="advancedFieldMnozicaElem" [value]="'advancedFieldMnozicaElem'">
              @if (this.advancedFieldMnozicaElemIn) {
                <ix-boolean
                  #advancedFieldMnozicaElemInComponent
                  field="advancedFieldMnozicaElemIn"
                  onLabel="Je v seznamu"
                  offLabel="Ni v seznamu"
                  [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
                  [class.padding-bottom]="true"
                  [readOnlyForce]="false"
                  (ixChange)="this.onLookupChange($event, true)"
                />
              }
              <ix-text-area
                #advancedFieldMnozicaElemComponent
                label=""
                field="advancedFieldMnozicaElem"
                style="width: 100%; display: block"
                [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
                [placeholder]="this.advancedFieldMnozicaElemPlaceholder"
                [readOnlyForce]="false"
                [style.max-width]="getMaxWidth()"
                [rows]="5"
                (ixChange)="this.onLookupChange($event, true)"
              />
            </p-tabpanel>
          }
          @if (this.advancedFieldObstaja !== undefined) {
            <p-tabpanel id="advancedFieldObstaja" [value]="'advancedFieldObstaja'">
              <ix-boolean
                #advancedFieldObstajaComponent
                field="advancedFieldObstaja"
                onLabel="Vrednost je vpisana"
                offLabel="Vrednost ni vpisana"
                [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
                [readOnlyForce]="false"
                (ixChange)="this.onLookupChange($event, true)"
              />
            </p-tabpanel>
          }
          @if (this.advancedFieldNapredno !== undefined) {
            <p-tabpanel id="advancedFieldNapredno" [value]="'advancedFieldNapredno'">
              <ix-text-area
                #advancedFieldNaprednoComponent
                label=""
                field="advancedFieldNapredno"
                style="width: 100%; display: block"
                [ixFormGroup]="this.ixFormGroupUtil.ixFormGroup"
                [placeholder]="this.advancedFieldNaprednoPlaceholder"
                [readOnlyForce]="false"
                [style.max-width]="getMaxWidth()"
                [rows]="5"
                (ixChange)="this.onLookupChange($event, true)"
              />
            </p-tabpanel>
          }
        </p-tabpanels>
      </p-tabs>
    </div>
  </ng-template>
</p-popover>
